import React from 'react';
import PropTypes from 'prop-types';
import Translation from '../../../translation/translation';

function MissingTyreIndexPostcode(props) {
    return (
        <span className="statusbar__missing-status">
            <span className="statusbar__add-information" onClick={props.onClick}>
                <Translation translationKey="catalog-missing-status-missing-tyre-index-postcode" />
            </span>
        </span>
    );
}

MissingTyreIndexPostcode.propTypes = {
    onClick: PropTypes.func.isRequired
};

export default MissingTyreIndexPostcode;
